import { FILTER_KEYWORD } from 'constants/header';

export interface SetFilterKeywordAction {
  type: typeof FILTER_KEYWORD.SET_FILTER_KEYWORD;
  filterKeyword: string | undefined;
}

export interface ClearFilterKeywordAction {
  type: typeof FILTER_KEYWORD.CLEAR_FILTER_KEYWORD;
}

export function setFilterKeyword(value?: string): SetFilterKeywordAction {
  return { type: FILTER_KEYWORD.SET_FILTER_KEYWORD, filterKeyword: value };
}

export function clearFilterKeyword(): ClearFilterKeywordAction {
  return { type: FILTER_KEYWORD.CLEAR_FILTER_KEYWORD };
}
